export default "__VITE_ASSET__BbirLc2Z__"